// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn--ErgwP","timesheerApproverSection":"timesheerApproverSection--OT5FC"};